export const API_ROOTS = {
  LIVE: 'https://amplifierapp.xyz/api_u/',
  TEST: 'https://test.amplifierapp.xyz/api_u/',
  SOCKET: 'https://socket.amplifierapp.xyz/',
  SOCKET_API: 'https://socket.amplifierapp.xyz/api/'
}

export const BASE_URL = API_ROOTS.TEST
export const SOCKET_BASE_URL = API_ROOTS.SOCKET_API
export const SOCKET_CONNECTION_URL = API_ROOTS.SOCKET

export const AUTHORIZATION_HEADER = 'Basic YW1wbGlmeTphbXBsaWZ5'

export const ENDPOINTS = {
  LOGIN: 'login',
  SOCIAL_LOGIN: 'social_login',
  SOCIAL_LOGIN_CHECK: 'social_login_check',
  REGISTER: 'register',
  GET_PROFILE: 'get_profile',
  EDIT_PROFILE: 'edit_profile',
  LOGIN_RESET: 'login_reset',
  LOGIN_RESET_VERIFY: 'login_reset_verify',
  CHANGE_PASSWORD: 'changepwd',
  DELETE_ACCOUNT: 'deleteaccount',
  UPDATE_TIMEZONE: 'update_timezone',
  LIVE_APPS_INVITEAPP: 'live_apps_inviteapp',
  GET_BUSINESS_LIST: 'get_business_list',
  LIST_REVIEW_BUSINESS: 'list_review_business',
  LIST_BUSINESS_REVIEWS: 'list_business_reviews',
  LIST_CHECKINS: 'list_checkins',

  NEARBY_FLYERS: 'nearby_flyers',
  SEARCH_FLYERS: 'search_flyers',
  HASHTAG_FLYERS: 'hashtag_flyers',
  SAVE_LOCATION: 'savelocation',
  GET_LOCATIONS: 'get_locations',
  GET_CHATS_FLYER_USER: 'get_chats_flyer_user',
  GET_CHATS_FLYER_USER_VIEW: 'get_chats_flyer_user_view',
  SEND_CHAT_FLYER: 'send_chat_flyer',
  SEND_SOCKET_MESSAGE: 'send_message',
  SAVED_FLYERS_USER: 'saved_flyers_user',
  LIST_ADDED_FLYER_LIVE: 'list_added_flyer_live',
  GET_FLYER_CONTENT_TYPES: 'get_flyer_content_types',
  GET_FLYER_CONTENT_TYPES_SECTIONS: 'get_flyer_content_types_sections',
  DETAIL_FLYER: 'detail_flyer',

  SAVE_FLYER: 'save_flyer',
  LIKE_FLYER: 'like_flyr',
  PUBLISH_UNPUBLISH_FLYER: 'publish_unpublish_flyer',
  FLYER_DELETE_USER: 'flyer_delete_user',
  FLYER_FOLLOW_USER: 'flyer_follow_user',

  VIEW_COMMENTS_FLYER: 'view_comments_flyer',
  ADD_COMMENT_FLYER: 'add_comment_flyer',

  ADD_FLYER: 'add_flyer',
  CHECKIN: 'checkin',
  UPDATE_FLYER: 'update_flyer',
  LIST_CATEGORY_FLYER: 'list_category_flyer',
  LIST_BOARDS_FLYER: 'list_boards_flyer',
  LIST_SAVED_FLYER_BOARDS: 'list_saved_flyer_boards',
  ADD_BOARD_FLYER: 'add_board_flyer',
  UPDATE_BOARD_FLYER: 'update_board_flyer'
}

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCa7RuhN7A2KFkmKtJ6TNYb8IFyUjty1DE',
  authDomain: 'netflyer-c325a.firebaseapp.com',
  projectId: 'netflyer-c325a',
  storageBucket: 'netflyer-c325a.firebasestorage.app',
  messagingSenderId: '964432364032',
  appId: '1:964432364032:web:5a409589a137c64af38ee5'
}
